/* Drag a catalog tile straight onto the plan. Mouse/pen only — on touch the
   tile is tapped and the plan tapped, so the catalog sheet can still scroll.
   A plain click (no movement) is left to the tile's click handler. */
import { hooks, pushUndo, state } from './state.ts';
import { canvas } from './render.ts';
import { snapV } from './snap.ts';
import { snapFixtureToWall } from './fixsnap.ts';
import { uid } from './utils.ts';

const DRAG_START_PX = 4;

export function beginPaletteDrag(key: string, e: PointerEvent): void {
  if (e.pointerType === 'touch' || e.button !== 0) return;
  const start = { x: e.clientX, y: e.clientY };
  let dragging = false;
  const toWorld = (cx: number, cy: number) => {
    const r = canvas.getBoundingClientRect(), v = state.view;
    return { over: cx >= r.left && cx <= r.right && cy >= r.top && cy <= r.bottom,
             p: { x: v.x + (cx - r.left) / v.zoom, y: v.y + (cy - r.top) / v.zoom } };
  };
  const move = (ev: PointerEvent) => {
    if (!dragging) {
      if (Math.hypot(ev.clientX - start.x, ev.clientY - start.y) < DRAG_START_PX) return;
      dragging = true;
      state.fixtureType = key;
      hooks.setTool('fixture');          // arms the ghost for this type
    }
    const { over, p } = toWorld(ev.clientX, ev.clientY);
    const gh = state.placeGhost; if (!gh) return;
    state.placePreview = over ? p : null;
    state.guides = [];
    if (over) {
      const pose = ev.altKey ? null : snapFixtureToWall(key, gh, p, state.doc.walls, snapV);
      if (pose) { gh.x = pose.x; gh.y = pose.y; gh.rot = pose.rot; state.guides.push({ kind: 'face', wall: pose.wall }); }
      else { gh.x = snapV(p.x); gh.y = snapV(p.y); }
    }
    hooks.requestDraw();
  };
  const up = (ev: PointerEvent) => {
    document.removeEventListener('pointermove', move); document.removeEventListener('pointerup', up);
    if (!dragging) return;
    const { over } = toWorld(ev.clientX, ev.clientY);
    const gh = state.placeGhost;
    state.guides = [];
    if (over && gh) {
      pushUndo();
      const f = { id: uid('f'), type: key, x: gh.x!, y: gh.y!, w: gh.w, h: gh.h, rot: gh.rot, label: '' };
      state.doc.fixtures.push(f);
      state.sel = new Set([f.id]);
      hooks.setTool('select');
      hooks.markDirty(); hooks.renderPanel();
      hooks.coach('fixture');
    } else hooks.requestDraw();   // let go off the plan: nothing placed, catalog stays open
  };
  document.addEventListener('pointermove', move);
  document.addEventListener('pointerup', up);
}
